/*=============================
=       Footer Locations      =
=============================*/

[].slice.call(document.querySelectorAll('.btn-loc-wrapper .button')).forEach(function(button) {
	button.addEventListener('click', function() {
		this.classList.toggle('selected');
		this.setAttribute('aria-selected', (this.getAttribute('aria-selected') == 'true' ? 'false' : 'true'));

		var panel = document.getElementById(this.getAttribute('aria-controls'));

		if(panel) {
			panel.classList.toggle('hidden');
		}
	})
});